import { render } from "./PraiseListItem.vue?vue&type=template&id=037c7c60&scoped=true"
import script from "./PraiseListItem.vue?vue&type=script&lang=js"
export * from "./PraiseListItem.vue?vue&type=script&lang=js"

import "./PraiseListItem.vue?vue&type=style&index=0&id=037c7c60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037c7c60"]])

export default __exports__